


















































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { add, bignumber } from 'mathjs'
import { zeroUnit } from '@/web-task/utils'

@Component({})
export default class MediateCost extends Vue {
	private max: number = 9999999.99
	private min: number = 0.0
	private visible: boolean = false
	private feeFields: any = [
		'medicalFee',
		'furtherMedicalFee',
		'mealsFee',
		'compensation',
		'caregiversFee',
		'commuteFee',
		'otherFee',
	]
	private feeMap: any = {
		medicalFee: '医疗费',
		furtherMedicalFee: '续医费',
		mealsFee: '住院伙食补助费',
		compensation: '误工费赔偿金额',
		caregiversFee: '护理费赔偿金额',
		commuteFee: '交通费赔偿金额',
		otherFee: '其他（物损、车损等）',
	}
	private noConciliation: boolean = false
	private currentTip: string = 'medicalFee'
	private tips: any = {
		medicalFee: {
			title: '医疗费',
			content:
				'说明：\n按照《机动车交通事故责任强制保险条例》第三十二条“医疗机构应当参照国务院卫生主管部门组织制定的有关临床诊疗指南，抢救、治疗道路交通事故中的受伤人员”。和《机动车商业总额和保险条款》第二十五条免责条款规定：“超出《道路交通事故受伤人员临床诊疗指南》和国家基本医疗保险同类医疗费用标准的费用部分”在免责范围内。',
		},
		mealsFee: {
			title: '住院伙食补助费',
			content:
				'计算公式为：当地住院伙食补助标准*实际住院天数（剔除挂床期）\n说明：\n1.当地住院伙食补助标准参照当地国家机关一般工作人员的出差伙食补助标准；\n2.挂床期指在医院住院期间未进行检查、治疗的日期。',
		},
	}

	@Prop()
	private currentForm!: any

	@Prop()
	private costTableInfo!: any

	@Prop()
	private mediateSetCost!: any

	@Prop()
	private noConciliationMap!: any

	@Prop()
	private index!: number

	private get initialMap() {
		let res: any = {},
			temp = this.costTableInfo[this.index]
		if (temp) {
			temp.forEach((item: any) => {
				res[item.id] = item.targetCost
			})
		}
		return res
	}

	@Watch('noConciliationMap')
	private onConciliationChange() {
		if (this.mediateSetCost) {
			// 发布调解前的设置金额
			// noConciliationMap - 是否勾选无需调解项下标数组
			this.noConciliation = this.noConciliationMap[this.index]
		} else {
			// 编辑金额时均可输入
			this.noConciliation = false
		}
	}

	private showTips(currentTip: string) {
		this.visible = true
		this.currentTip = currentTip
	}

	private keepNumber(str: string) {
		let temp = str.match(/-?\d+/)
		if (temp) {
			return str.slice(temp.index)
		} else {
			return ''
		}
	}

	private zeroUnit(number: any) {
		return zeroUnit(number, '元')
	}

	private onFeeInput() {
		this.$nextTick(() => {
			// 设置总金额
			let sum = 0,
				costMap: any = {},
				costArr: any = []
			for (const item of this.feeFields) {
				const value = this.currentForm.getFieldValue(
					`fees[${this.index}].${item}`
				)
				if (
					value &&
					typeof value === 'number' &&
					value <= this.max &&
					value >= this.min
				) {
					sum = Number(add(bignumber(sum), bignumber(value)).toString())
					costMap[this.feeMap[item]] = value
					costArr.push(this.feeMap[item])
				}
			}
			this.currentForm.setFieldsValue({
				[`fees[${this.index}].sumFee`]: this.zeroUnit(sum),
			})

			// 仅设置金额发起调解时需协议同时改变
			if (!this.mediateSetCost) {
				return
			}
			// 设置调解协议中相关项
			this.$emit('onCostChange', {
				index: this.index,
				costMap: costMap,
				costArr: costArr,
				total: sum,
			})
		})
	}
}
